import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useMemo, type ReactNode } from 'react';

import '@fontsource-variable/manrope';
import '@fontsource-variable/space-grotesk';

import { createTheme } from './create-theme';

/** As chaves do `localStorage`; o script do `index.html` lê as mesmas. */
export const MODE_STORAGE_KEY = 'vd-mode';
export const COLOR_SCHEME_STORAGE_KEY = 'vd-color-scheme';

type Props = {
  children: ReactNode;
};

/**
 * O modo padrão é o do sistema; a escolha da pessoa fica no `localStorage`. `noSsr` faz o
 * primeiro render já ler o que está salvo, em vez de renderizar claro e corrigir depois.
 */
export function ThemeProvider({ children }: Props) {
  const theme = useMemo(() => createTheme(), []);

  return (
    <MuiThemeProvider
      theme={theme}
      defaultMode="system"
      modeStorageKey={MODE_STORAGE_KEY}
      colorSchemeStorageKey={COLOR_SCHEME_STORAGE_KEY}
      disableTransitionOnChange
      noSsr
    >
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
